import {lazyRegister} from '@/Core/lazyRegister';
import {
    SessionInfo
} from "@/models";
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class SessionInfoManagerService {
    static readonly $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    getAll(data?: { email?: string, number: string }, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<SessionInfo[]>('/v2/api/session', data, cancelToken);
    };


    deleteById(parent: string, id: string) {
        return this.baseApiFactory.delete<boolean>('/v2/api/session/' + id, {parent});
    };
}

lazyRegister.service('SessionInfoManagerService', SessionInfoManagerService);
